import { CaseClassificationActionTypes, IFetchCaseClassificationAsyncAction } from "./caseClassificationTypes"

export const fetchCaseClassificationAction = (): IFetchCaseClassificationAsyncAction => {
  return {
    type: CaseClassificationActionTypes.FETCH_CASE_CLASSIFICATION_ASYNC_PENDING
  }
}
